<template>
    <HeaderContent title="Directory Transportation"/>
    <ActionContent ctaText="Transportation" :filterDate="false" @action="modal = !modal " />
    <!-- <StatisticData title="Destination Statistics" :data="statistics" /> -->
    <TransportationForm :modal="modal" @update:modal="modal = $event"></TransportationForm>
    <DataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    </DataTable>

    <!-- TransportationDetail -->
     <TransportationDetail v-model="detailTransportation.togle" :data="detailTransportation.data" :title="detailTransportation.title"></TransportationDetail>
    
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import TransportationForm from './TransportationForm.vue';
import DataTable from '@/components/DataTable.vue';
import transportationDummy from '@/dummy-data/transportation.js'
import TransportationDetail from './action/TransportationDetail.vue';
import { ref } from 'vue'

export default{
    name : 'TransportationIndex',
    components : { HeaderContent, ActionContent, TransportationForm, DataTable, TransportationDetail },
    setup(){
        const modal = ref(false)
        const data = transportationDummy
        const detailTransportation = ref({
            title : '',
            data : []
        })
        const headers = ref([
            {key : 'id',label: 'ID'},
            {key : 'car_type', label : 'Car Type', },
            {key : 'car_code', label : 'Car Code', },
            {key : 'pax', label : 'Pax', },
            {key : 'price', label : 'Price', },
            {key : 'action', label : 'Action', },  
        ])
        const customActions = ref([
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                console.log('Edit action clicked for:', item);
                    
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                console.log('Delete action clicked for:', item);
                
                }
            },
            
        ]);
        return {
            modal,
            detailTransportation,
            data,
            headers,
            customActions
        }
    }
}
</script>

